import { render, staticRenderFns } from "./collect-route-task.vue?vue&type=template&id=607cc968&scoped=true&"
import script from "./collect-route-task.js?vue&type=script&lang=js&"
export * from "./collect-route-task.js?vue&type=script&lang=js&"
import style0 from "./collect-route-task.scss?vue&type=style&index=0&id=607cc968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607cc968",
  null
  
)

export default component.exports